// extracted by mini-css-extract-plugin
module.exports = {"circle":"CircleLoader_circle__2Hv_K","circle_completed":"CircleLoader_circle_completed__3n8R6","circle_failed":"CircleLoader_circle_failed__4Ir4M"};